import { Toaster as SonnerToaster } from "sonner";

export const Toaster = () => (
  <SonnerToaster
    position="top-right"
    toastOptions={{
      classNames: {
        toast: "!opacity-80 !bg-bg-dark",
        title:
          "!text-md !font-semibold ![&+div]:!text-sm !text-primary-inverse-text",
        description: "!text-sm !opacity-90 !text-primary-inverse-text",
        success: "!text-stroke-interactive",
        error: "!text-destructive",
        info: "!text-blue-50",
        closeButton:
          "!bg-bg-dark !text-primary-inverse-text/50 !border-none !transition-opacity",
      },
    }}
    richColors
    theme="dark"
    closeButton
  />
);
